export default __webpack_public_path__ + "static/media/stolen-black.b7087aa6.svg";